import { useCallback } from "react";
import { Session } from "@newLayouts/auth/libs/common";
import { useSessionContext } from "@newHooks/context/session/session.context";

export interface RefreshSessionOption {
  redirectTo?: string;
}

export const useRefreshSession = () => {
  const { onSetSession } = useSessionContext();

  const refreshSession = useCallback(
    (session: Session, option?: RefreshSessionOption) => {
      onSetSession(session);

      if (option?.redirectTo) {
        document.location.href = option.redirectTo;
      }
    },
    [onSetSession]
  );

  return refreshSession;
};
